import React from 'react'
import Link from 'gatsby-link'
import Image from 'gatsby-image'
import styled from 'styled-components'
import ProjectSlider from '../components/slider'
import { Parallax, ParallaxProvider } from 'react-scroll-parallax'
import Layer1 from '../assets/layer1.png'
import Layer2 from '../assets/layer2.png'
import Layer3 from '../assets/layer3.png'
import Layer4 from '../assets/layer4.png'
import Bricks from '../assets/bricks.png'
import ArrowTip from '../assets/arrow/tip.png'
import ArrowBack from '../assets/arrow/back.png'
import Door from '../components/door'
import Dots from '../assets/dots.svg'
import { HelmetDatoCms } from 'gatsby-source-datocms'

const HomeWrapper = styled.div`
  .header {
    position: relative;
    background-color: #7ecfd1;
    padding-bottom: 100px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: fit;
    @media screen and (max-width: 768px) {
      background-position: bottom;
    }
  }
  .header-body {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .laptopWrapper {
    position: relative;
    margin: 2rem 0px;
    @media screen and (min-width: 769px) {
      padding: 10rem;
    }
    height: 80%;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
  }
  .bgImage {
    img {
      object-fit: contain !important;
    }
  }
  .headerContent {
    @media screen and (min-width: 960px) {
      margin: 0 20%;
      padding-top: 80px;
    }
    .is-flex {
      justify-content: center;
      align-items: baseline;
      img {
        margin: 1rem;
      }
    }
    z-index: 1;
    .title {
      font-family: Pacifico;
      color: #004e64;
      font-size: 3.5rem;
    }
    .subtitle {
      font-family: Oswald;
      font-weight: 700;
      color: #004e64;
      text-transform: uppercase;
      font-size: 3rem;
      @media screen and (max-width: 640px) {
        font-size: 2.5rem;
      }
    }
    p {
      color: #004e64;
      font-family: Montserrat;
      font-weight: 500;
      font-size: 1.25rem;
    }
    .button {
      padding: 1.5rem;
      font-family: Montserrat;
      font-weight: 700;
    }
  }

  .parallax-wrapper {
    overflow: hidden;
    position: relative;
  }
  .parallax-container {
    position: relative;
    display: flex;
    height: 256px;

    > img {
      height: 100%;
      width: 100%;
      z-index: 10;
    }
  }

  .static {
    z-index: 14;
    position: relative;
    height: 100%;
    * {
      height: 100%;
    }
    img {
      object-position: bottom !important;
    }
  }

  .layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .parallax-inner,
    .gatsby-image-outer-wrapper,
    .gatsby-image-wrapper {
      height: 100%;
    }

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .layer-outer {
    position: absolute;
    height: 100%;
    width: 100%;
  }

  #door-section {
    background-image: url(${Bricks});
    background-position: 50% 100px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom;

    padding-top: 5rem;
    padding-bottom: 0px !important;

    .arrow-container {
      flex-direction: row;
      justify-content: center;
    }
    .arrow {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 5px;
      img {
        width: 32px;
        height: 27px;
      }
    }

    .door-wrapper {
      @media screen and (min-width: 767px) {
        margin-bottom: -100px;
      }
    }
  }
  .clients {
    display: flex;
    justify-content: center;
    vertical-align: middle;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;

    .client-logo-wrapper {
      min-width: 100px;
      margin: 1rem 2rem;

      .gatsby-image-outer-wrapper {
        display: flex;
      }
    }
    .client-logo {
      margin: 0 auto;
      img {
      }
    }
  }
`

const SliderContainer = styled.div`
  .slick-list {
    overflow: visible;
  }
`

const OffsetsMin = [0, '55%', '55%', '60%']
const OffsetsMax = [0, -20, -35, -50]

const IndexPage = ({ data }) => (
  <HomeWrapper>
    <HelmetDatoCms seo={data.datoCmsHomePage.seoMetaTags} />
    <section
      className="header"
      style={{
        backgroundImage: `url(${data.datoCmsHomePage.headerBg1.url})`,
      }}
    >
      <div className="header-body">
        <div className="laptopWrapper container">
          <Image
            resolutions={data.datoCmsHomePage.headerBg2.resolutions}
            alt=""
            className="bgImage image is-hidden-mobile"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
          />
          <div className="headerContent has-text-centered">
            <div className="is-flex">
              <img src={Dots} alt="dots" />
              <h1 className="pacifico has-text-dark is-size-1">Marketing</h1>
              <img src={Dots} alt="dots" />
            </div>
            {/* <Image */}
            {/*   resolutions={data.datoCmsHomePage.leadImage.resolutions} */}
            {/*   alt="" */}
            {/* /> */}
            <h2 className="subtitle">Built to Succeed</h2>
            <div className="content">
              <p className="has-text-weight-semibold">
                We build custom marketing solutions that invigorate your brand
                and solve well-defined business goals.
              </p>
            </div>
            <Link
              to="/about"
              className="button is-info is-outlined is-uppercase"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </section>
    <section className="section">
      <div className="container has-text-centered">
        <div className="columns is-centered">
          <div className="column is-half">
            <h2 className="is-size-2 has-text-dark is-uppercase has-text-weight-bold">
              Work That Matters
            </h2>
            <p className="is-size-5 has-text-dark has-text-weight-semibold">
              We've worked with many passionate businesses to develop their
              brand and online presence.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section className="section" style={{ overflowX: 'hidden' }}>
      <section className="slider">
        <SliderContainer className="container">
          <ProjectSlider slides={data.datoCmsHomePage.featuredProjects} />
        </SliderContainer>
      </section>
    </section>
    <section className="section">
      <div className="container ">
        <div className="columns is-centered">
          <div className="column is-half has-text-centered">
            <p className="subtitle has-text-centered has-text-dark">
              Want to see more?
            </p>
            <Link className="button is-light" to="/work">
              View All Projects
            </Link>
          </div>
        </div>
      </div>
    </section>
    <section className="section">
      <div className="container">
        <p className="has-text-centered title has-text-dark">
          Some of our happy clients...
        </p>
        <div className="clients columns">
          {data.datoCmsHomePage.clients.map(
            client =>
              client.logo.resolutions && (
                <div className="client-logo-wrapper">
                  <Image
                    className="client-logo"
                    resolutions={client.logo.resolutions}
                    key={client.id}
                  />
                </div>
              )
            // <img src={client.logo.url} alt="" />
          )}
        </div>
      </div>
    </section>
    <section className="parallax-wrapper section is-paddingless">
      <ParallaxProvider>
        <div className="parallax-container">
          {data.datoCmsHomePage.parallax.map((layers, index) => (
            <div className="layer-outer" key={index}>
              {index == 0 ? (
                <div className="static">
                  <Image sizes={layers.sizes} />
                </div>
              ) : (
                <Parallax
                  className="layer"
                  offsetYMax={OffsetsMax[index]}
                  offsetYMin={OffsetsMin[index]}
                  slowerScrollRate={true}
                  styleOuter={{ zIndex: '-' + index }}
                >
                  <Image sizes={layers.sizes} />
                </Parallax>
              )}
            </div>
          ))}
        </div>
      </ParallaxProvider>
    </section>
    <section
      id="door-section"
      className="section is-large has-background-dark has-text-centered"
    >
      <div className="columns is-multiline is-centered">
        <div className="column is-12">
          <h2 className="title is-size-1 has-text-white is-uppercase has-text-centered">
            Leave the BS
          </h2>
          <div className="columns">
            <div className="column is-flex arrow-container">
              <div className="arrow">
                <img src={ArrowBack} alt="" />
              </div>
              <p className="subtitle has-text-primary is-size-1 pacifico is-marginless">
                At The Door
              </p>
              <div className="arrow">
                <img src={ArrowTip} alt="" />
              </div>
            </div>
          </div>
          <p className="subtitle is-size-4 has-text-primary has-text-weight-bold">
            Marketing that is focused on well-defined goals.
          </p>
        </div>
        <div className="column is-half">
          <p className="has-text-white is-size-5 ">
            Our team will open the door for you to greater marketing
            opportunities. We define goals, build the foundation, and execute
            the plan. Our digital marketing solutions will delight your
            customers over and over!
            {/* Not to make Tina happy about her hastily made back of the napkin */}
            {/* logo sketch, but rather delight your customers over and over! */}
          </p>
        </div>
        <div className="door-wrapper column is-12">
          <Door />
        </div>
      </div>
    </section>
  </HomeWrapper>
)

export default IndexPage

export const Home = graphql`
  query HomeQuery {
    datoCmsHomePage {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      clients {
        id
        logo {
          resolutions(
            width: 100
            imgixParams: { fm: "png", auto: "compress" }
          ) {
            ...GatsbyDatoCmsResolutions
          }
          url
        }
      }
      headerBg1 {
        id
        url
      }
      headerBg2 {
        resolutions(width: 900, imgixParams: { fm: "png", auto: "compress" }) {
          ...GatsbyDatoCmsResolutions
        }
      }
      leadImage {
        resolutions(width: 300, imgixParams: { fm: "png", auto: "compress" }) {
          ...GatsbyDatoCmsResolutions_noBase64
        }
      }
      featuredProjects {
        id
        thumbnail {
          resolutions(
            width: 900
            imgixParams: { fm: "jpg", auto: "compress" }
          ) {
            ...GatsbyDatoCmsResolutions_noBase64
          }
        }
        title
        subtitle
        slug
        accent {
          red
          green
          blue
          hex
        }
      }
      parallax {
        id
        sizes(maxWidth: 1800) {
          ...GatsbyDatoCmsSizes
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js